import { useState } from 'react';

interface ProductImageGalleryProps {
  mainImage: string;
  thumbnails: string[];
}

export function ProductImageGallery({
  mainImage = '🌲',
  thumbnails = ['🌲', '🌲', '🌲', '🌲'],
}: ProductImageGalleryProps) {
  const [selectedImage, setSelectedImage] = useState(mainImage);

  return (
    <div className="bg-white rounded-lg border border-neutral-200 p-8 shadow-sm">
      {/* Main Image */}
      <div className="aspect-square bg-gradient-to-br from-warning-100 to-warning-200 rounded-lg flex items-center justify-center mb-4">
        <div className="text-8xl">{selectedImage}</div>
      </div>

      {/* Thumbnail Grid */}
      <div className="grid grid-cols-4 gap-3 mt-4">
        {thumbnails.map((thumbnail, index) => (
          <div
            key={index}
            onClick={() => setSelectedImage(thumbnail)}
            className="aspect-square bg-gradient-to-br from-warning-100 to-warning-200 rounded-lg flex items-center justify-center cursor-pointer border-2 border-transparent hover:border-primary-500 transition-all"
          >
            <div className="text-2xl">{thumbnail}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
